//FROMCDN
await themeComponent(theme.components['mc-element'], false);
await themeResource(theme.resources['mc-utils'], false);

class McFormErrors extends McElement {

  connectedCallback() {
    this.checkErrors();
  }

  checkErrors = () => {
    if (this.innerHTML.length > 0) {
      this.activate();
    } else {
      this.deactivate();
    }
  }

  clear = () => {
    this.innerHTML = '';
    this.deactivate();
  }

  showError = (content) => {
    this.innerHTML = content;
    this.activate();
  }
}

if (!customElements.get('mc-form-errors')) {
  customElements.define('mc-form-errors', McFormErrors);
  //McUtils.addCss(`https://cdn.jsdelivr.net/npm/ict-shopify@${McUtils.VERSION}/v2/css/mc-form-errors.css`);
}

window.McFormErrors = McFormErrors;
export default McFormErrors;